import { render, staticRenderFns } from "./AddColumn.vue?vue&type=template&id=4b670fb9"
import script from "./AddColumn.vue?vue&type=script&lang=js"
export * from "./AddColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports